import React from "react";
import PropTypes from "prop-types";

import "./Spinner.css";

export default class Spinner extends React.Component {
  
  static propTypes = {
    color: PropTypes.string,
    size: PropTypes.string
  }
  
  static defaultProps = {
    color: "default",
    size: "text"
  }
  
  render() {
    const { color, size } = this.props;
    const classNames = [ "spinner", `spinner--color-${color} spinner--size-${size}` ];
    return (
      <div className={classNames.join(" ")}>
        <div className="spinner__wheel"></div>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Spinner.js